// src/components/SignIn.tsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate, Link } from 'react-router-dom';




const SignIn: React.FC = () => {
    const navigate = useNavigate(); // Initialize the hook

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { userRole, signIn } = useAuth();


    // console.log(userRole);

    useEffect(() => {
        if (userRole) {
            // Assuming the token contains the user role or you fetch the role based on the token.
            if (userRole != null) {
                navigate("/")
            }
        }
    }, [userRole]);


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        signIn(encodeURIComponent(email), password);
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>Sign In</h3>
            <div>
                <label>Email: </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div>
                <label>Password: </label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <div className='forgot_password'>
                <p><Link to="/request_password_reset">Forgot password?</Link></p>
            </div>
            <input type="submit" value="Submit"></input>
            
        </form>
    );
}

export default SignIn;
